module.exports = __webpack_public_path__ + "img/check.bdff98c2.png";